import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  upload,
  uploadItemValidate,
  getFileBlob,
  getExport,
} from "./regulerdiscAPI";

const initialState = {
  data: [],
  dataId: null,
  dataHistory: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "regulerDisc/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchRegulerDisc = createAsyncThunk(
  "regulerDisc/fetchRegulerDisc",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("regulerDisc/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "regulerDisc/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "regulerDisc/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "regulerDisc/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "regulerDisc/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "regulerDisc/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "regulerDisc/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const fetchTemplate = createAsyncThunk(
  "ultis/fetchTemplate",
  async (payload) => {
    const response = await getFileBlob(payload);
    return response;
  }
);

export const fetchExport = createAsyncThunk(
  "regulerDisc/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const regulerDiscSlice = createSlice({
  name: "regulerDisc",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchRegulerDisc.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchRegulerDisc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = regulerDiscSlice.actions;

export const selectData = (state) => state.regulerDisc.data;
export const selectRegulerDisc = (state) => state.regulerDisc.data;
export const selectId = (state) => state.regulerDisc.dataId;
export const selectIdHistory = (state) => state.regulerDisc.dataHistory;
export const selectLoading = (state) => state.regulerDisc.loading;
export const selectLoadingTemplate = (state) => state.regulerDisc.loading;
export const selectError = (state) => state.regulerDisc.error;
export const selectPageNo = (state) => state.regulerDisc.pageNo;
export const selectPageSize = (state) => state.regulerDisc.pageSize;
export const selectTotalRecord = (state) => state.regulerDisc.totalRecord;
export const selectSelected = (state) => state.regulerDisc.selected;
export const selectResult = (state) => state.regulerDisc.result;

export default regulerDiscSlice.reducer;
